import { atom, RecoilState } from "recoil";
import { recoilPersist } from 'recoil-persist';
import { getDateWithoutTime } from "../Helpers/DateFormatter";

const { persistAtom } = recoilPersist();

export type BBBEEScorecard = {
    scorecardId: string;
    scorecardName: string;
    scorecardTypeId?: number;
    scorecardTypeName?: string;
    ReportPeriodDateFrom?: Date,
    ReportPeriodDateTo?: Date,
    isConsolidated?: boolean;
}

export const BBBEEScorecardAtom: RecoilState<BBBEEScorecard> = atom<BBBEEScorecard>({
    key: 'BBBEEScorecardAtom',
    default: {
        scorecardId: "",
        scorecardName: "",
        scorecardTypeName: "",
        ReportPeriodDateFrom: getDateWithoutTime(new Date()),
        ReportPeriodDateTo: getDateWithoutTime(new Date()),
    } as BBBEEScorecard,
    effects_UNSTABLE: [persistAtom]
});